import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { CustomAlert, CustomButton } from "../../../../../shared/uiComponents";
import { useCheckPermission } from "../../../../../shared/Helpers/hooks";
import AllocationDetails from "./allocationDetails";
import { PERMISSIONS } from "../../../../../App/constants";

const Allocate = ({ therapistId }: { therapistId: string }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [params] = useSearchParams();
  const { permissionGranted } = useCheckPermission(PERMISSIONS.INSURANCE_AUTHORIZATION.ALLOCATE);

  if (!permissionGranted) return <></>
  return (
    <>
      <CustomButton
        title="Allocate hours"
        onClick={() => setOpen(true)}
        disabled={!therapistId || !params.get("authId") || !params.get("detailsId")}
      />
      <CustomAlert
        open={open}
        onClose={() => setOpen(false)}
        Content={({ onClose }) => (
          <AllocationDetails therapistId={therapistId} onClose={onClose} />
        )}
      />
    </>
  );
};

export default Allocate;
